import { httpPost, httpDownload } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import {
    getInventoryASR,
    setInventoryASRError,
    setInventoryASRColSearchStr,
    sortInventoryASRItems,
    setInventoryASRPageSize,
    setInventoryASRFilter,
    applyInventoryASRFilter,
    resetInventoryASRData
} from '../../../constants/model-reducers/external/inventory/circuit-details/asr.settings';
import { convertToFormatLocalDate } from '../../../utils/helpers.utils';

const defaultState = () => ({
    isInventoryASRLoaded: false,
    isInventoryASRError: false,
    inventoryASRItems: DEFAULT_TABLE_RESULT_MODEL,
    inventoryASRColSort: '',
    inventoryASRIsSortedAsc: true,
    inventoryASRTableFilterList: [],
    inventoryASRTableFilterApply: false,
});

const initialState = defaultState();

export const inventoryASRActions = {
    getInventoryASR: (pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryASR.inventoryASRItems;
        const { inventoryASRIsSortedAsc, inventoryASRColSort, inventoryASRTableFilterList, inventoryASRTableFilterApply } = state().inventoryASR;

        var userId = sessionStorage.getItem('UserID');

        var data = {
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: userId,
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: inventoryASRColSort,
            IsSortAscending: inventoryASRIsSortedAsc,
            TableFilterList: inventoryASRTableFilterList,
            ApplyFilter: inventoryASRTableFilterApply
        };

        var inventoryItems = await httpPost('external/inventory/getASRInventoryItems', data);
        if (inventoryItems.ok === false) {
            dispatch({
                type: setInventoryASRError,
                isInventoryASRError: true,
                isInventoryASRLoaded: false
            });
        } else {
            dispatch({
                type: getInventoryASR,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryASRLoaded: true,
                isInventoryASRError: false
            });
        }
    },
    setResetSearch: () => async (dispatch, state) => {
        
        const { inventoryASRItems } = state().inventoryASR;
        var inventoryASRItemsUpd = {
            ...inventoryASRItems,
            "Headers": {}
        }

        dispatch({
            type: setInventoryASRColSearchStr,
            data: inventoryASRItemsUpd,
            isInventoryASRError: false,
            isInventoryASRLoaded: false
        });
    },
    setInventoryASRColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { inventoryASRItems } = state().inventoryASR;
        var inventoryASRItemsUpd = {
            ...inventoryASRItems,
            "Headers": {
                ...inventoryASRItems.Headers,
                [key]: {

                    ...inventoryASRItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInventoryASRColSearchStr,
            data: inventoryASRItemsUpd,
            isInventoryASRError: false,
            isInventoryASRLoaded: true
        });
    },
    sortInventoryASRItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().inventoryASR.inventoryASRItems.Pagination;
        const { inventoryASRItems, inventoryASRTableFilterList, inventoryASRTableFilterApply } = state().inventoryASR;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: inventoryASRItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...inventoryASRItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: inventoryASRTableFilterList,
            ApplyFilter: inventoryASRTableFilterApply
        };
        var resInventoryASRItems = await httpPost('external/inventory/getASRInventoryItems', data);
        if (resInventoryASRItems.ok === false) {
            dispatch({
                type: setInventoryASRError,
                isInventoryASRError: true,
                isInventoryASRLoaded: false
            });
        } else {
            dispatch({
                type: sortInventoryASRItems,
                inventoryASRItems: Object.keys(resInventoryASRItems).length > 0 ? resInventoryASRItems : DEFAULT_TABLE_RESULT_MODEL,
                inventoryASRColSort: columnClicked,
                inventoryASRIsSortedAsc: isSortedAsc,
                isInventoryASRLoaded: true
            });
        }
    },

    resizeInventoryASRPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInventoryASRPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractInventoryASR: () => async (dispatch, state) => {
        const { Headers } = state().inventoryASR.inventoryASRItems;
        const { inventoryASRIsSortedAsc, inventoryASRColSort, inventoryASRTableFilterList, inventoryASRTableFilterApply } = state().inventoryASR;

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var filename = `ATEM ${dealName} ASR Extract – ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: inventoryASRColSort,
            IsSortAscending: inventoryASRIsSortedAsc,
            FileName: filename,
            TableFilterList: inventoryASRTableFilterList,
            ApplyFilter: inventoryASRTableFilterApply
        };

        httpDownload('external/inventory/getASRExtractInventoryItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addInventoryASRFilter: (tableFilter) => (dispatch, state) => {
        const { inventoryASRTableFilterList } = state().inventoryASR;

        var filterList = [...inventoryASRTableFilterList, tableFilter];

        dispatch({
            type: setInventoryASRFilter,
            filterList: filterList
        })
    },

    removeInventoryASRFilter: (removeIndex) => (dispatch, state) => {
        const { inventoryASRTableFilterList } = state().inventoryASR;

        var filterList = inventoryASRTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setInventoryASRFilter,
            filterList: filterList
        })
    },

    applyInventoryASRFilter: (isApply) => (dispatch, state) => {
        const { inventoryASRTableFilterList } = state().inventoryASR;

        dispatch({
            type: applyInventoryASRFilter,
            applyFilter: isApply,
            filterList: isApply ? inventoryASRTableFilterList : []
        });
    },

    saveInventoryASRCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryASR.inventoryASRItems;
        const { inventoryASRIsSortedAsc, inventoryASRColSort, inventoryASRTableFilterList, inventoryASRTableFilterApply } = state().inventoryASR;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.ASRInventoryManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/inventory/saveCustomizeColumns', customizeFormData);

            dispatch({
                type: setInventoryASRError,
                isInventoryASRError: true,
                isInventoryASRLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: inventoryASRColSort,
                IsSortAscending: inventoryASRIsSortedAsc,
                TableFilterList: inventoryASRTableFilterList,
                ApplyFilter: inventoryASRTableFilterApply
            };

            var inventoryItems = await httpPost('external/inventory/getASRInventoryItems', data);

            dispatch({
                type: getInventoryASR,
                inventoryItems: Object.keys(inventoryItems).length > 0 ? inventoryItems : DEFAULT_TABLE_RESULT_MODEL,
                isInventoryASRLoaded: true,
                isInventoryASRError: false
            });
        }
        catch (e) {
            dispatch({
                type: setInventoryASRError,
                isInventoryASRError: true,
                isInventoryASRLoaded: false
            });
        }
    },

    resetInventoryASRData: () => async (dispatch) => {
        dispatch({ type: resetInventoryASRData, data: DEFAULT_TABLE_RESULT_MODEL });
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryASR:
            return {
                ...state,
                inventoryASRItems: action.inventoryItems,
                isInventoryASRLoaded: action.isInventoryASRLoaded,
                isInventoryASRError: action.isInventoryASRError
            };
        case setInventoryASRError:
            return {
                ...state,
                isInventoryASRError: action.isInventoryASRError,
                isInventoryASRLoaded: action.isInventoryASRLoaded
            }
        case setInventoryASRColSearchStr:
            return {
                ...state,
                inventoryASRItems: action.data,
                isInventoryASRLoaded: action.isInventoryASRLoaded,
                isInventoryASRError: action.isInventoryASRError
            }
        case sortInventoryASRItems:
            return {
                ...state,
                inventoryASRItems: action.inventoryASRItems,
                inventoryASRColSort: action.inventoryASRColSort,
                inventoryASRIsSortedAsc: action.inventoryASRIsSortedAsc,
                isInventoryASRLoaded: action.isInventoryASRLoaded
            }
        case setInventoryASRPageSize:
            return {
                ...state,
                inventoryASRItems: {
                    ...state.inventoryASRItems,
                    Pagination: {
                        ...state.inventoryASRItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setInventoryASRFilter:
            return {
                ...state,
                inventoryASRTableFilterList: action.filterList
            }
        case applyInventoryASRFilter:
            return {
                ...state,
                inventoryASRTableFilterApply: action.applyFilter,
                inventoryASRTableFilterList: action.filterList
            }
        case resetInventoryASRData:
            return {
                ...state,
                inventoryASRItems: action.data
            };
        default:
            return state;
    }
};